import { render, staticRenderFns } from "./FacturasView.vue?vue&type=template&id=2def270b"
import script from "./FacturasView.vue?vue&type=script&lang=js"
export * from "./FacturasView.vue?vue&type=script&lang=js"
import style0 from "./FacturasView.vue?vue&type=style&index=0&id=2def270b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports